export default __webpack_public_path__ + "static/media/Ostali 2.1dd55717.jpg";